"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stats = void 0;
const statsGetAgentInsightsStatsAgentInsightsAgentIdGet_js_1 = require("../funcs/statsGetAgentInsightsStatsAgentInsightsAgentIdGet.js");
const statsGetAgentsAreaInsightsStatsAgentsAreaInsightsGet_js_1 = require("../funcs/statsGetAgentsAreaInsightsStatsAgentsAreaInsightsGet.js");
const statsGetPropertiesStatsPropertiesStreetGroupPropertyIdGet_js_1 = require("../funcs/statsGetPropertiesStatsPropertiesStreetGroupPropertyIdGet.js");
const sdks_js_1 = require("../lib/sdks.js");
const fp_js_1 = require("./types/fp.js");
class Stats extends sdks_js_1.ClientSDK {
    /**
     * Get Agent Insights
     *
     * @remarks
     * Get agents insights for a specific agent in an area
     *
     * ## Valid query parameters
     *
     * <details>
     * <summary>Click to view information on valid query parameters for this endpoint</summary>
     *
     * The following combinations of query parameters are valid, invalid combinations will result in a `400 Bad Request`
     * with details why they are not valid.
     *
     * | Combination                       | Description                                                                                                                                                 |
     * | :-------------------------------- | :---------------------------------------------------------------------------------------------------------------------------------------------------------- |
     * | Postcode only                     | Will return only the agents insights that have listed in the postcode.                                                                                                            |
     * | Outcode only                      | Will return only the agents insights that have listed in the outcode.                                                                                                             |
     * | Sector only                       | Will return only the agents insights that have listed in the sector.
     * | Single point parameter and radius | Will return all agents insights that have listed within the radius of the lat/lon given.                                                                                          |
     * | Multiple point parameters         | Will return all agents insights that have listed enclosed within a polygon defined by the given point parameters. At least 3 point parameters must be passed to define a polygon. |
     *
     * </details>
     *
     * ## Time Snapping
     *
     * <details>
     * <summary>Click to view information on using time snapping for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-time-snapping) for more information on using time snapping.
     * </details>
     */
    async getAgentInsightsStatsAgentInsightsAgentIdGet(security, request, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsGetAgentInsightsStatsAgentInsightsAgentIdGet_js_1.statsGetAgentInsightsStatsAgentInsightsAgentIdGet)(this, security, request, options));
    }
    /**
     * Get Agents Area Insights
     *
     * @remarks
     * Get agents insights in an area
     *
     * ## Valid query parameters
     *
     * <details>
     * <summary>Click to view information on valid query parameters for this endpoint</summary>
     *
     * The following combinations of query parameters are valid, invalid combinations will result in a `400 Bad Request`
     * with details why they are not valid.
     *
     * | Combination                       | Description                                                                                                                                                 |
     * | :-------------------------------- | :---------------------------------------------------------------------------------------------------------------------------------------------------------- |
     * | Postcode only                     | Will return only the agents insights that have listed in the postcode.                                                                                                            |
     * | Outcode only                      | Will return only the agents insights that have listed in the outcode.                                                                                                             |
     * | Sector only                       | Will return only the agents insights that have listed in the sector.
     * | Single point parameter and radius | Will return all agents insights that have listed within the radius of the lat/lon given.                                                                                          |
     * | Multiple point parameters         | Will return all agents insights that have listed enclosed within a polygon defined by the given point parameters. At least 3 point parameters must be passed to define a polygon. |
     *
     * </details>
     *
     * ## Time Snapping
     *
     * <details>
     * <summary>Click to view information on using time snapping for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-time-snapping) for more information on using time snapping.
     * </details>
     */
    async getAgentsAreaInsightsStatsAgentsAreaInsightsGet(security, request, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsGetAgentsAreaInsightsStatsAgentsAreaInsightsGet_js_1.statsGetAgentsAreaInsightsStatsAgentsAreaInsightsGet)(this, security, request, options));
    }
    /**
     * Get Properties
     *
     * @remarks
     * Calculate statistics for a given property.
     *
     * - Estimated Values
     *     - By month
     *     - Delta increase/decrease in price over the time period.
     * - Average price per square foot
     * - Estimated rental value
     */
    async getPropertiesStatsPropertiesStreetGroupPropertyIdGet(security, streetGroupPropertyId, filterEndDate, filterStartDate, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsGetPropertiesStatsPropertiesStreetGroupPropertyIdGet_js_1.statsGetPropertiesStatsPropertiesStreetGroupPropertyIdGet)(this, security, streetGroupPropertyId, filterEndDate, filterStartDate, options));
    }
}
exports.Stats = Stats;
//# sourceMappingURL=stats.js.map